import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import useGetLocalCarDetail from "../../../hooks/useGetLocalCarsDetails";
import { CgFileDocument } from "react-icons/cg";
import { PiUsersFill } from "react-icons/pi";
import { getToken } from "../../../utils/storageUtils";
import SwiperGallery from "./SwiperGallery";
import useTimer from "../../../hooks/useTimer";
import TimeLeftCounter from "../../vehicle/Vehicle-page/TimeLeftCounter";
import CurrencyInput from "react-currency-input-field";
import { TiLockClosed } from "react-icons/ti";
import { statusOptions } from "../../../utils/filtersData/statusOptions";
import { RxCopy } from "react-icons/rx";
import { toast } from "react-toastify";
import CopyURLModal from "./CopyURLModal";
import TimeAgo from "react-timeago";
import { FaLink } from "react-icons/fa";
import { getAllBidsLocalCar } from "../../../hooks/useGetAllBidsOnLocalCars";
import SimilarCars from "./similarCars";
import { useFunds } from "../../../context/FundsContext";
import useSaveLocalCar from "../../../hooks/useSaveLocalCar";
import useDeleteSaveLocalCar from "../../../hooks/useDeleteSaveLocalCar";
import { useSavedLocalCars } from "../../../context/SavedLocalCarsIdscontext";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { BsHeart, BsHeartFill } from "react-icons/bs";
import SignInModal from "../../vehicle/Vehicle-page/modals/SignInModal";
import LoginModal from "../../modals/LoginModal";
import BidConfirmationModal from "./BidConfirmationModal";
import usePlaceLocalCarBid from "../../../hooks/usePlaceLocalCarBid";
import { ClipLoader } from "react-spinners";
import { formatCurrency } from "../../../utils/formatCurrency";
import { BsInfoCircle } from "react-icons/bs";
 

import { useRef } from "react";
import TooltipInfo from "../../common/TooltipInfo";
import Pusher from "pusher-js";
import ReportPreview from "../../vehicle/Vehicle-page/report/ReportPreview";
import VehicleMetaTags from "../../../utils/VehicleMetaTags";
import CounterOfferModal from "../../ui/modals/CounterOfferModal";
import { approveCounterOffer, rejectCounterOffer, createCounterOffer, getCounterOffersByCarId } from "../../../services/userService";

const LocalVehicleDetail = () => {
  const { id } = useParams();
  const { fetchFunds } = useFunds();
  const location = useLocation();
  const queryId = useMemo(() => {
    try {
      return new URLSearchParams(location.search).get("id");
    } catch {
      return null;
    }
  }, [location.search]);
  const winningBid = location?.state?.winningBid;
  const passedBidPrice = location?.state?.bidPrice;
  const passedOfferPrice = location?.state?.offerPrice;
  const passedCounterOfferId = location?.state?.counterOfferId;
  const { handleSaveLocalCar } = useSaveLocalCar();
  const { deleteSavedLocalCar } = useDeleteSaveLocalCar();
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isCarSaved, setIsCarSaved] = useState(false);
  const navigate = useNavigate();

  const [allBids, setAllBids] = useState(null);
  const hasBids = Array.isArray(allBids?.data?.data) && allBids.data.data.length > 0;
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const [isCounterModalOpen, setIsCounterModalOpen] = useState(false);
  const [counterOfferAmount, setCounterOfferAmount] = useState("");
  const [isOfferActionLoading, setIsOfferActionLoading] = useState(false);
  const [activeOfferPrice, setActiveOfferPrice] = useState(() => passedOfferPrice ?? null);
  const [activeCounterOfferId, setActiveCounterOfferId] = useState(() => passedCounterOfferId ?? null);
  const [latestCounterOffer, setLatestCounterOffer] = useState(null);
  const [counterOfferBuyerId, setCounterOfferBuyerId] = useState(null);
  const [counterOfferSellerId, setCounterOfferSellerId] = useState(null);

  const { user } = useAuthContext();

  const routeCarId = id || queryId;
  const { carDetailData, fetchCarDetail } =
    useGetLocalCarDetail(`local-cars/get-car?id=${routeCarId}`);
  const { fundsData } = useFunds();


  const [bidAmount, setBidAmount] = useState(() => {
    const currentBid = carDetailData?.data?.car?.currentBid || 0;
    return currentBid + 500;
  });
  const { savedIds, refetchSavedIds } = useSavedLocalCars();

  

  const { placeBid, placebidLoading, placeBiderror, placeBidSuccess } =
    usePlaceLocalCarBid();

  useEffect(() => {
    setIsCarSaved(savedIds?.data && savedIds?.data.includes(String(routeCarId)));
  }, [savedIds, routeCarId]);

  useEffect(() => {
    fetchCarDetail();
  }, [fetchCarDetail]);

  // Compute latest bid price from bid history as fallback for offer summary
  const derivedBidPrice = useMemo(() => {
    const entries = allBids?.data?.data || [];
    if (!entries.length) return null;
    const sorted = [...entries].sort((a, b) => new Date(b?.bid?.createdAt || 0) - new Date(a?.bid?.createdAt || 0));
    const latest = sorted[0];
    const price = Number(latest?.bid?.bidPrice);
    return isNaN(price) ? null : price;
  }, [allBids?.data?.data]);

  // Helpers to compute remaining time and expiry for counter offers
  const calculateRemainingTime = (createdAt) => {
    if (!createdAt) return null;
    const created = new Date(createdAt);
    const expiry = new Date(created.getTime() + 24 * 60 * 60 * 1000);
    const now = new Date();
    const remaining = expiry - now;
    if (remaining <= 0) return null;
    const hours = Math.floor(remaining / (1000 * 60 * 60));
    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
    return { hours, minutes, seconds, totalMs: remaining };
  };

  const isOfferExpired = (offer) => {
    if (!offer) return true;
    if (offer.isValid === false) return true;
    const remaining = calculateRemainingTime(offer.createdAt);
    return remaining === null;
  };

  // Fetch counter offers and set the latest
  useEffect(() => {
    const carId = carDetailData?.data?.car?.id || routeCarId;
    if (!carId) return;
    let isMounted = true;

    const fetchCounterOffers = async () => {
      try {
        const resp = await getCounterOffersByCarId(carId);
        const offers = Array.isArray(resp?.data?.offers) ? resp.data.offers : [];
        const buyerId = resp?.data?.buyer?.id || null;
        const sellerId = resp?.data?.seller?.id || null;
        if (!offers || !offers.length) {
          if (!isMounted) return;
          setLatestCounterOffer(null);
          // keep any passed values if present
          setActiveOfferPrice((prev) => prev ?? null);
          setActiveCounterOfferId((prev) => prev ?? null);
          setCounterOfferBuyerId(buyerId);
          setCounterOfferSellerId(sellerId);
          return;
        }
        const sorted = [...offers].sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));
        const latest = sorted[0];
        if (!isMounted) return;
        setLatestCounterOffer(latest);
        setActiveOfferPrice(Number(latest?.counterOfferPrice) || null);
        setActiveCounterOfferId(latest?.id ?? null);
        setCounterOfferBuyerId(buyerId);
        setCounterOfferSellerId(sellerId);
      } catch (e) {
        if (!isMounted) return;
        setLatestCounterOffer(null);
        setActiveOfferPrice(passedOfferPrice ?? null);
        setActiveCounterOfferId(passedCounterOfferId ?? null);
        setCounterOfferBuyerId(null);
        setCounterOfferSellerId(null);
      }
    };

    fetchCounterOffers();
    return () => { isMounted = false; };
  }, [carDetailData?.data?.car?.id, routeCarId, passedOfferPrice, passedCounterOfferId]);

  const targetTime = useMemo(
    () =>
      carDetailData?.data?.car?.auction_date
        ? new Date(carDetailData?.data?.car?.auction_date)
        : null,
    [carDetailData?.data?.car?.auction_date]
  );

  const { days, hours, minutes, seconds } = useTimer(targetTime);

  const ValidDate =
    targetTime && (days > 0 || hours > 0 || minutes > 0 || seconds > 0);

  const [liveData, setLiveData] = useState({ currentBid: null, noOfBids: null, userID: null });
  const bidFetchTimeoutRef = useRef(null);

  const currentBidValue = useMemo(() => {
    const apiBid = Number(carDetailData?.data?.car?.currentBid || 0);
    const liveBid = Number(liveData?.currentBid || 0);
    return Math.max(apiBid, liveBid);
  }, [carDetailData?.data?.car?.currentBid, liveData?.currentBid]);

  const isCarOwner = useMemo(() => {
    if (!user || !carDetailData?.data?.dealer) return false;
    return (
      user?.id?.toString() ===
      carDetailData?.data?.dealer?.userID?.toString()
    );
  }, [user, carDetailData?.data?.dealer]);

  const buyNowPrice = carDetailData?.data?.car?.buyNowPrice;
  const auctionEnded = !ValidDate || (buyNowPrice && currentBidValue >= buyNowPrice);

  const [userHasBid, setUserHasBid] = useState(false);
  const [userBidStatus, setUserBidStatus] = useState(null);

  useEffect(() => {
    if (!user) {
      setUserHasBid(false);
      setUserBidStatus(null);
      return;
    }

    const entries = allBids?.data?.data || [];
    const userIdString = user?.id?.toString();
    const userBids = entries.filter(
      (e) => e?.bid?.userID?.toString() === userIdString
    );

    const highestOverall = entries.reduce((max, e) => {
      const price = Number(e?.bid?.bidPrice) || 0;
      return price > max ? price : max;
    }, 0);
    const userHighest = userBids.reduce((max, e) => {
      const price = Number(e?.bid?.bidPrice) || 0;
      return price > max ? price : max;
    }, 0);
    const userHasActive = userBids.some((e) => Boolean(e?.bid?.isValid));

    if (auctionEnded) {
      // Determine final status at auction end
      if (userHighest > 0 && userHighest === highestOverall) {
        setUserHasBid(true);
        setUserBidStatus("won");
      } else if (userBids.length > 0) {
        setUserHasBid(true);
        setUserBidStatus("lost");
      } else {
        setUserHasBid(false);
        setUserBidStatus(null);
      }
      return;
    }

    if (liveData?.userID && userIdString) {
      const isUserLeading = liveData.userID.toString() === userIdString;
      setUserHasBid(isUserLeading || userBids.length > 0);
      setUserBidStatus(isUserLeading ? "winning" : userBids.length > 0 && userHasActive ? "outbid" : "outbid");
      return;
    }

    if (!entries.length) {
      setUserHasBid(false);
      setUserBidStatus(null);
      return;
    }

    setUserHasBid(userBids.length > 0);
    setUserBidStatus(userHasActive ? "winning" : userBids.length > 0 ? "outbid" : null);
  }, [user, allBids, auctionEnded, liveData?.userID]);

  const getTimeDifference = () => {
    if (!carDetailData?.data?.car?.auction_date) return null;

    const auctionDate = new Date(carDetailData.data.car.auction_date);
    const currentDate = new Date();

    if (currentDate > auctionDate) return null;

    const diffInMilliseconds = auctionDate - currentDate;
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

    // Return only if the time difference is within one hour (60 minutes)
    if (diffInMinutes > 60) return null;

    return `Live in ${diffInMinutes} ${diffInMinutes === 1 ? "minute" : "minutes"}`;
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const data = await getAllBidsLocalCar({
  //         localCarID: carDetailData?.data?.car?.id,
  //       });
  //       setAllBids(data);
  //     } catch (error) {
  //     }
  //   };

  //   fetchData();
  // }, [carDetailData]);

  useEffect(() => {
    const carId = carDetailData?.data?.car?.id;
    if (!carId) return;

    const fetchData = async () => {
      try {
        const data = await getAllBidsLocalCar({ localCarID: carId });
        setAllBids(data);
      } catch (error) {
        console.error("Error fetching bids:", error);
      }
    };

    fetchData();
  }, [carDetailData?.data?.car?.id]);

  useEffect(() => {
    if (!id) return;

    const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_ID, {
      cluster: "ap2",
      authEndpoint: `${process.env.REACT_APP_API_BASE_URL}pusher/auth/live-bidding`,
      auth: {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    });

    const channel = pusher.subscribe(`presence-car-${id}`);


    const handler = (data) => {
      const message = data?.message || {};
      setLiveData({
        currentBid: message.bid_price,
        noOfBids: message.noOfBids,
        userID: message.userID,
      });

      // Show toast for other users' bids
      const { userID } = message;
      const currentUserId = user?.id;
      const isOtherUserBid = userID && currentUserId && userID.toString() !== currentUserId.toString();

      if (isOtherUserBid) {
        toast.success("Someone placed new bid");
      }
    };

    channel.bind("car-notifications", handler);

    return () => {
      // channel.unbind("car-notifications", handler);
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, [id, user?.id]);

  // Debounced refresh of bids after live update
  useEffect(() => {
    const carId = carDetailData?.data?.car?.id;
    if (liveData.currentBid == null || !carId) return;
    if (bidFetchTimeoutRef.current) clearTimeout(bidFetchTimeoutRef.current);
    bidFetchTimeoutRef.current = setTimeout(async () => {
      try {
        const data = await getAllBidsLocalCar({ localCarID: carId });
        setAllBids(data);
      } catch (e) {}
    }, 400);

    return () => {
      if (bidFetchTimeoutRef.current) clearTimeout(bidFetchTimeoutRef.current);
    };
  }, [liveData.currentBid, carDetailData?.data?.car?.id]);

  useEffect(() => {
    if (shouldRefetch) {
      fetchCarDetail();
      setShouldRefetch(false);
    }
  }, [shouldRefetch, fetchCarDetail]);

  useEffect(() => {
    if (placeBidSuccess) {
      setShouldRefetch(true);
        const carId = carDetailData?.data?.car?.id;
  if (carId) {
    getAllBidsLocalCar({ localCarID: carId }).then(setAllBids).catch(console.error);
  }
      toast.success("Bid has been placed successfully");
      document.getElementById("local_bid_modal").close();
    }

    if (placeBiderror) {
      toast.error(placeBiderror);
      
    }
  }, [placebidLoading, placeBidSuccess, placeBiderror, user?.id, carDetailData?.data?.car?.id]);

  useEffect(() => {
    if (currentBidValue) {
      setBidAmount(currentBidValue + 500);
    }
  }, [currentBidValue]);

  const handleSaveClick = (id) => {
    const stringLotId = String(id);

    if (!user) {
      setLoginModalOpen(true);
      return;
    }

    if (isCarSaved) {
      setIsCarSaved(false);

      deleteSavedLocalCar(stringLotId)
        .then(() => {
          refetchSavedIds();
          toast.success("Car unsaved successfully");
        })
        .catch(() => {
          setIsCarSaved(true);
          toast.error("Failed to unsave car. Please try again.");
        });
    } else {
      setIsCarSaved(true);
      handleSaveLocalCar(stringLotId)
        .then(() => {
          refetchSavedIds();
          toast.success("Car saved successfully");
        })
        .catch(() => {
          setIsCarSaved(false);
          toast.error("Failed to save car. Please try again.");
        });
    }
  };

  const currentStatus = statusOptions.find(
    (option) => option.id === carDetailData?.data?.car?.titlesStatus
  );

  // const handlePlaceMaxBid = async () => {
  //   if (bidAmount <= carDetailData?.data?.car?.currentBid) {
  //     showToast("Your Bidding Amount Is Less Than Current Bid", "error");
  //   } else {
  //     setIsBidModalOpen(true);
  //   }
  // };

  const handleBidPlace = async () => {
    await placeBid({
      id: carDetailData?.data?.car?.id,
      currentBid: bidAmount,
      type: "pre-auction",
    });
    await fetchFunds();
  };

  const handlePlaceBid = () => {
    if (!user) {
      document.getElementById("sign_in_modal").showModal();
    } else {
      document.getElementById("local_bid_modal").showModal();
    }
  };

  const closeLoginModal = () => {
    setLoginModalOpen(false);
  };

  const handleCloseBidModal = () => {
    document.getElementById("local_bid_modal").close();
  };

  const handleBuyNowClick = () => {
    if (!user) {
      document.getElementById("sign_in_modal").showModal();
    } else {
      document.getElementById("buy_now_modal").showModal();
    }
  };

  const handleBuyNow = async () => {
    await placeBid({
      id: carDetailData?.data?.car?.id,
      currentBid: carDetailData?.data?.car?.buyNowPrice,
      isBuyNow: true,
      type: "pre-auction",
    });
    await fetchFunds();

     document.getElementById("buy_now_modal").close();
  };

  const totalFunds = fundsData?.data?.totalDeposits || 0;

  const handleLiveAutcionNavigation = () => {
    if (id) {
      navigate(`/live-auction-portal?id=${id}`);
      console.log(`Navigating to live auction portal for car ID: ${id}`);
    } else {
      navigate("/live-auction-portal");
      console.log("Navigating to live auction portal without specific car ID");
    }
  };

  // Removed automatic redirect to live auction portal when auction time is reached

  

  return (
    <>
      {carDetailData?.data?.car && (
        <VehicleMetaTags carData={{
          car: carDetailData?.data?.car,
          carType: "local"
        }} />
      )}
      <div className="hidden lg:block vehicle-detail">
        <div className="w-[15.5] flex flex-col pt-[20vh]">
          <div className="text-[2.6vw] font-semibold text-white">
            Local Vehicle
          </div>
          <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
            <Link to="/">
              <button className="hover:text-white hover:scale-110 duration-150">
                Home
              </button>
            </Link>
            /
            <button className="hover:text-white hover:scale-110 duration-150">
              Local Vehicle
            </button>
          </div>
        </div>
      </div>

      <div className="mt-[80px] lg:mt-0">
        {carDetailData?.data?.car?.auction_date ? (
          ValidDate ? (
            <div className=""></div>
          ) : (
            <div className="bg-[#CA0000] text-md lg:text-[1vw] shadow   lg:mt-0 tracking-wider text-white text-center p-[0.7vw] font-bold">
              Preliminary Bidding is Over for this vehicle
            </div>
          )
        ) : (
          <div className="bg-[#217bf0]  text-md lg:text-[1vw] shadow  tracking-wider text-white text-center p-[0.7vw] font-bold">
            Auction date is not decided yet, Be one on the top of bidding list
          </div>
        )}
      </div>

      {carDetailData && (
        <div className="bg-gray-100">
          <div className="flex flex-col lg:flex-row pt-4 lg:py-[0.5vw] justify-between mx-auto w-[95%] lg:w-[84vw]  pb-[20px]">
            <div className="w-[100%]  lg:w-[48%] ">
              {carDetailData?.data?.car?.carImages ? (
                <div className="w-full">
                  <SwiperGallery
                    images={carDetailData?.data?.car?.carImages}
                    carData={carDetailData?.data?.car}
                  />
                </div>
              ) : null}
              <div className="w-[100%]  lg:hidden lg:w-[48%]">
                <div>
                  <div className="flex  justify-between mt-[50px] lg:mt-2 lg:mb-[3vh]">
                    <div className="flex w-full justify-between px-[0.5vw] items-center gap-2 rounded-[0.5vw] bg-white">
                      {currentStatus && (
                        <div
                          className={`w-4 h-4 lg:w-[1.5vw] lg:h-[1.5vw] rounded-full ml-3 ${currentStatus?.bgHex}`}
                        >
                          <span
                            title={currentStatus.id}
                            className="text-white w-full h-full text-16 font-bold flex items-center justify-center"
                          >
                            {currentStatus.letter}
                          </span>
                        </div>
                      )}
                      <p className="text-[16px] lg:text-[1.7vw] mt-[10] font-urbanist font-semibold ">
                        {carDetailData?.data?.car?.year}{" "}
                        {carDetailData?.data?.car?.make}{" "}
                        {carDetailData?.data?.car?.model}
                      </p>
                      {typeof winningBid !== "undefined" && (
                        <span className="text-green-700 font-semibold text-[12px] lg:text-[0.9vw]">
                          {`Winning Bid: $${Number(winningBid).toLocaleString()}`}
                        </span>
                      )}
                      <div className="flex items-center gap-x-2 lg:gap-x-[0.5vw]">
                        <button
                          onClick={() => handleSaveClick(id)}
                          className="text-[12px] lg:text-18 font-semibold flex border items-center gap-2 lg:gap-[0.5vw] px-2 lg:px-[1vw] py-1 lg:py-[0.5vw] rounded-lg transition bg-gray-100 hover:bg-gray-200 text-gray-800"
                        >
                          {isCarSaved && user ? (
                            <BsHeartFill className=" text-red-500" />
                          ) : (
                            <BsHeart className=" text-gray-500" />
                          )}
                        </button>
                        <button
                          title="Copy URL"
                          onClick={() =>
                            document
                              .getElementById("copy_url_modal")
                              .showModal()
                          }
                          className=" bg-blue-500 hover:bg-blue-600 text-white  rounded-lg text-[12px] lg:text-18 font-semibold flex border items-center gap-2 lg:gap-[0.5vw] px-2 lg:px-[1vw] py-1 lg:py-[0.5vw]  transition"
                        >
                          <FaLink className="lg:text-20" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2 flex-col lg:flex-row justify-between   mb-[3vh]">
                    <div className="flex px-[0.5vw] gap-2 lg:gap-[0.5vw] items-center lg:w-[20vw] lg:h-[6.7vh] rounded-[0.5vw] bg-white">
                      <div className="flex justify-center items-center rounded-lg lg:rounded-[0.5vw] p-2 lg:w-[2.5vw] lg:h-[5vh] bg-[#CA0000]">
                        <PiUsersFill
                          color="white"
                          className="lg:w-[1.2vw] lg:h-[2.5vh]"
                        />
                      </div>
                      <div className="text-left">
                        <p className="text-[14px] lg:text-[0.7vw] text-[#7a798a]">
                          Owned by
                        </p>
                        <p className="text-[14px] lg:text-[0.9vw] font-urbanist font-semibold text-green-600   py-[0.1vw] px-[0.2vw] rounded-[0.2vw]">
                          {carDetailData?.data?.dealer?.dealershipName ||
                            "Private Party"}
                        </p>
                      </div>
                    </div>
                    <div className="flex px-[0.5vw] gap-2 lg:gap-[0.5vw]   items-center lg:w-[20vw] lg:h-[6.7vh] rounded-[0.5vw] bg-white">
                      <div className="flex justify-center items-center p-2  rounded-lg lg:rounded-[0.5vw] lg:w-[2.5vw] lg:h-[5vh] bg-[#CA0000]">
                        <CgFileDocument
                          color="white"
                          className="lg:w-[1.2vw] lg:h-[2.5vh]"
                        />
                      </div>
                      <div className="text-left">
                        <p className="text-[14px] lg:text-[0.7vw] text-[#7a798a]">
                          Sale Platforms
                        </p>
                        <p className="text-[14px] lg:text-[0.9vw] font-urbanist font-semibold text-green-600  py-[0.1vw] px-[0.2vw] rounded-[0.2vw]">
                          Bidcaribbean
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex   flex-col lg:flex-row gap-2 justify-between">
                    <div className={`bg-white flex flex-col justify-evenly w-full ${auctionEnded ? 'lg:w-full' : 'lg:w-[20vw]'} px-[0.5vw] py-[1.08] leading-[4.33vh] rounded-lg`}>
                      <div className="flex justify-between items-center">
                        <p className="font-urbanist text-[#7a798a] text-[14px] lg:text-[0.85vw] ml-2">
                          VIN :
                        </p>
                        <div className="flex gap-2x items-center">
                          <p className="font-urbanist font-bold text-[13px] lg:text-[0.97vw] mx-2">
                            {carDetailData?.data?.car?.vin}
                          </p>
                          <RxCopy
                            title="Copy VIN"
                            className="cursor-pointer py-[0.1vh] text-[14px] text-gray-600 hover:text-gray-800"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                carDetailData?.data?.car?.vin
                              );
                              toast.success("Copied to clipboard!");
                            }}
                          />
                        </div>
                      </div>
                      <div className="flex justify-between items-center">
                        <p className="font-urbanist text-[#7a798a] text-[14px] lg:text-[0.85vw] ml-2">
                          Year/Make :
                        </p>
                        <p className="font-urbanist font-bold text-[13px] lg:text-[0.97vw] ml-2">
                          {carDetailData?.data?.car?.year +
                            " " +
                            carDetailData?.data?.car?.make}
                        </p>
                      </div>
                      <div className="flex justify-between items-center">
                        <p className="font-urbanist text-[#7a798a] text-md text-[14px] lg:text-[0.85vw] ml-2">
                          Model:
                        </p>
                        <p className="font-urbanist font-bold text-[13px] lg:text-[0.97vw] ml-2">
                          {carDetailData?.data?.car?.model}
                        </p>
                      </div>
                    </div>
                    {!auctionEnded && (
                    <div className="flex flex-col  lg:w-[20vw]  leading-[4.33vh] rounded-[0.5vw] ">
                      <div className="flex flex-col bg-white px-[0.5vw] py-[1.08vh] justify-between rounded-[0.5vw]">
                        <div className="flex justify-between items-center">
                          <p className="font-urbanist text-[#7a798a] text-md  text-[14px] lg:text-[0.85vw] ml-[0.5vw]">
                            Current Bid:
                          </p>

                          <p className="font-urbanist font-bold text-[13px] lg:text-[0.97vw] ml-2">
                            ${" "}
                            {currentBidValue.toLocaleString()}
                          </p>
                        </div>
                        <div className="flex justify-between items-center">
                          <p className="font-urbanist text-[#7a798a] text-md text-[14px] lg:text-[0.85vw] ml-[0.5vw]">
                            No of Bids :
                          </p>
                          <p className="font-urbanist font-bold text-md text-[13px] lg:text-[0.97vw] ml-[0.5vw]">
                            {liveData?.noOfBids || carDetailData?.data?.car?.noOfBids || 0}
                          </p>
                        </div>
                      </div>
                    </div>
                    )}
                  </div>
                  {carDetailData?.data?.car?.auction_date ? (
                    ValidDate && (!buyNowPrice || currentBidValue < buyNowPrice) ? (
                      <>
                        <TimeLeftCounter
                          days={days}
                          hours={hours}
                          minutes={minutes}
                          seconds={seconds}
                        />
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}

                  {getTimeDifference() ? (
                    <div
                      onClick={handleLiveAutcionNavigation}
                      className="flex justify-center my-[2vh] py-[0.5vw] items-center gap-x-[0.5vw] text-lg animate-pulse rounded-[0.7vw] text-white font-semibold bg-gradient-to-l from-green-700 to-green-600 hover:opacity-90 duration-300 shadow-md transform w-full"
                    >
                      {getTimeDifference()}
                    </div>
                  ) : (
                    <div>
                      {user && userHasBid && userBidStatus && (
                        <div
                          className={`mt-2 mb-2 p-3 text-center font-semibold rounded-md text-white ${
                            userBidStatus === "winning"
                              ? "bg-green-600"
                              : userBidStatus === "outbid"
                              ? "bg-orange-500"
                              : userBidStatus === "won"
                              ? "bg-green-700"
                              : "bg-red-600"
                          }`}
                        >
                          {userBidStatus === "winning" && "You are currently Winning"}
                          {userBidStatus === "outbid" && "You have been Outbid"}
                          {userBidStatus === "won" && "You Won the Auction! 🎉"}
                          {userBidStatus === "lost" && "You Lost the Auction"}
                        </div>
                      )}
                      {ValidDate && (!buyNowPrice || currentBidValue < buyNowPrice) && (
                        <div className="mt-6">
                          <label className="block text-[16px] font-semibold lg:text-[0.875vw] text-gray-900 mb-[1vh]">
                            Enter Your Final Bid
                          </label>
                          <CurrencyInput
                            id="input-example"
                            name="minPrice"
                            placeholder="enter your bid amount in USD"
                            prefix="$"
                            className={`border lg:text-[1vw] py-[0.9vh] px-[1vw] rounded-[0.5vw] w-full mt-[1.5vh] bg-white`}
                            defaultValue={
                              carDetailData?.data?.car?.currentBid
                                ? carDetailData?.data?.car?.currentBid + 500
                                : 500
                            }
                            decimalsLimit={2}
                            value={bidAmount}
                            onValueChange={(value) => setBidAmount(value)}
                            allowNegativeValue={false}
                            maxLength={12}
                            disabled={isCarOwner}
                          />
                        </div>
                      )}
                      <button
                        onClick={handlePlaceBid}
                        className={`flex justify-center mt-[2.167vh] items-center gap-x-[0.5vw] h-[5.4vh] text-lg mb-[2.167vh] rounded-[0.7vw] text-white font-semibold w-full ${
                          isCarOwner
                            ? "bg-red-600 cursor-not-allowed"
                            : !ValidDate
                            ? "bg-gray-500 cursor-not-allowed opacity-50"
                            : buyNowPrice && currentBidValue >= buyNowPrice
                            ? "bg-gray-300 cursor-not-allowed"
                            : Number(bidAmount) <= currentBidValue
                            ? "bg-red-600 cursor-not-allowed"
                            : "bg-red-600 hover:bg-red-700"
                        }`}
                        disabled={
                          isCarOwner || !ValidDate || (buyNowPrice && currentBidValue >= buyNowPrice) || Number(bidAmount) <= currentBidValue
                        }
                      >
                        {placebidLoading ? (
                          <ClipLoader color="#ffffff" size={20} />
                        ) : (
                          <>
                            <TiLockClosed className="lg:w-[1.3vw] lg:h-[2.8vh]" />
                             <span className="text-md lg:text-[1.1vw]">
                               {isCarOwner
                                 ? "This car belongs to you"
                                 : !ValidDate || (buyNowPrice && currentBidValue >= buyNowPrice)
                                 ? "AUCTION ENDED"
                                 : "PLACE MAX BID"}
                             </span>
                          </>
                        )}
                        {Number(bidAmount) <= currentBidValue && ValidDate && (!buyNowPrice || currentBidValue < buyNowPrice) && (
                          <TooltipInfo content="please place higher than current bid">
                            <BsInfoCircle size={15} className="hover:text-blue-800 duration-200" />
                          </TooltipInfo>
                        )}
                      </button>

                      {buyNowPrice != null && (
                        <button
                          onClick={handleBuyNowClick}
                          className={`flex justify-center mt-[2.167vh] items-center gap-x-[0.5vw] h-[5.4vh] text-lg mb-[2.167vh] rounded-[0.7vw] bg-gradient-to-l text-white font-semibold duration-300 transform w-full ${
                            isCarOwner
                              ? "from-green-700 to-green-600 hover:opacity-90"
                              : !ValidDate
                              ? "bg-gray-500 cursor-not-allowed opacity-50"
                              : currentBidValue >= buyNowPrice
                              ? "bg-red-600 cursor-not-allowed"
                              : "bg-gradient-to-l from-green-700 to-green-600 hover:opacity-90"
                          }`}
                          disabled={isCarOwner || !ValidDate || currentBidValue >= buyNowPrice}
                        >
                          <>
                            <span className="text-md lg:text-[1.1vw]">
                              {!ValidDate || currentBidValue >= buyNowPrice ? "FINAL BID PRICE" : "BUY NOW"}
                            </span>
                            <span className="text-md lg:text-[1.1vw]">
                              {!ValidDate || currentBidValue >= buyNowPrice
                                ? currentBidValue?.toLocaleString("en-US", { style: "currency", currency: "USD" }) || "N/A"
                                : buyNowPrice != null
                                ? buyNowPrice.toLocaleString("en-US", { style: "currency", currency: "USD" })
                                : "N/A"}
                            </span>
                          </>
                        </button>
                      )}
                      {buyNowPrice == null && auctionEnded && !isCarOwner && (
                        <button
                          disabled
                          className={
                            "flex justify-center mt-[2.167vh] items-center gap-x-[0.5vw] h-[5.4vh] text-lg mb-[2.167vh] rounded-[0.7vw] text-white font-semibold w-full bg-gray-500 cursor-not-allowed opacity-50"
                          }
                        >
                          <span className="text-md lg:text-[1.1vw]">FINAL BID PRICE</span>
                          <span className="text-md lg:text-[1.1vw]">
                            {(typeof winningBid !== "undefined" ? Number(winningBid) : currentBidValue).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })}
                          </span>
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <section className="bg-white p-[1.5vw] my-4 rounded-lg shadow-md">
                <h2 className="text-xl lg:leading-[1.75vw] lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2.1vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.4vw]">
                  Vehicle Info
                </h2>
                <div className="space-y-[2vh] lg:leading-[1vw] text-sm lg:text-[0.875vw]">
                  <InfoRow
                    label="Make/Model"
                    value={
                      carDetailData?.data?.car?.make +
                      " " +
                      carDetailData?.data?.car?.model
                    }
                  />
                  <InfoRow
                    label="Year"
                    value={carDetailData?.data?.car?.year || "N/A"}
                  />
                  <InfoRow
                    label="Mileage"
                    value={
                      carDetailData?.data?.car?.mileage.toLocaleString() ||
                      "N/A"
                    }
                  />
                  <InfoRow
                    label="Transmission"
                    value={carDetailData?.data?.car?.transmission || "N/A"}
                  />
                  <InfoRow
                    label="Modification"
                    value={carDetailData?.data?.car?.modification || "N/A"}
                  />
                  {/* <InfoRow
                    label="Start Code"
                    value={carDetailData?.data?.car?.titlesStatus || "N/A"}
                  /> */}
                  <InfoRow
                    label="Start Code"
                    value={
                      currentStatus ? (
                        <div className="flex items-center gap-2">
                          <BsInfoCircle
                            title={currentStatus.description}
                            className="text-base text-gray-500 cursor-pointer"
                          />
                          <span
                            className={`font-semibold ${currentStatus.hex}`}
                          >
                            {currentStatus.label}
                          </span>
                        </div>
                      ) : (
                        "N/A"
                      )
                    }
                  />

                  <InfoRow
                    label="Significant Flaws"
                    value={
                      carDetailData?.data?.car?.significantFlaws || "No Flaws"
                    }
                  />
                </div>
              </section>
              <section className="bg-white p-[1.5vw] my-4 rounded-lg shadow-md">
                <h2 className="text-xl  lg:leading-[1.75vw] lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2.1vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.4vw]">
                  Vehicle Description
                </h2>
                <div className="space-y-[2vh] lg:leading-[1.5vw] text-sm lg:text-[0.875vw]">
                  {carDetailData?.data?.car?.description}
                </div>
              </section>
              <section className="bg-white p-[1.5vw] my-4 rounded-lg shadow-md">
                <h2 className="text-xl lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2.1vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.4vw]">
                  Vehicle Location & Title Info
                </h2>
                <div className="space-y-[2vh] lg:leading-[1.5vw] text-sm lg:text-[0.875vw]">
                  <InfoRow
                    label="Country"
                    value={carDetailData?.data?.car?.carLocation}
                  />
                  <InfoRow
                    label="Island"
                    value={carDetailData?.data?.car?.carState || "N/A"}
                  />
                  <InfoRow
                    label="Island Titled"
                    value={carDetailData?.data?.car?.carTitledAt || "N/A"}
                  />
                  <InfoRow
                    label="Titled Info"
                    value={carDetailData?.data?.car?.carTitledInfo || "N/A"}
                  />
                </div>
              </section>
              {(() => {
                // Only show Offer Summary to authenticated user involved in the counter offer
                if (!user) return false;
                const userIdString = user?.id?.toString();
                const involved = (userIdString === counterOfferBuyerId?.toString()) || (userIdString === counterOfferSellerId?.toString());
                // If no fetched offer yet, allow showing when props are passed from Orders
                const hasPassed = (passedOfferPrice != null || passedCounterOfferId != null);
                return involved || hasPassed;
              })() && (
                <section className="bg-white p-[1.5vw] my-4 rounded-lg shadow-md">
                  <h2 className="text-xl lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2.1vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.4vw]">
                    Offer Summary
                  </h2>
              <div className="max-w-md">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                      <div className="bg-gray-50 rounded-md p-3">
                        <p className="text-gray-600">Last Current Bid</p>
                    <p className="font-semibold">{(passedBidPrice ?? derivedBidPrice ?? currentBidValue)?.toLocaleString("en-US", { style: "currency", currency: "USD" })}</p>
                      </div>
                      <div className="bg-gray-50 rounded-md p-3">
                        <p className="text-gray-600">Counter Offer</p>
                    <p className="font-semibold">{activeOfferPrice != null ? Number(activeOfferPrice).toLocaleString("en-US", { style: "currency", currency: "USD" }) : "N/A"}</p>
                    
                      </div>
                    </div>
                {(() => {
                  // Only authenticated users involved in this offer can see actions
                  if (!user) return false;
                  const userIdString = user?.id?.toString();
                  const isInvolved = (userIdString === counterOfferBuyerId?.toString()) || (userIdString === counterOfferSellerId?.toString());
                  if (!isInvolved) return false;
                  // Determine whose turn it is: opposite of last sender
                  const lastSender = latestCounterOffer?.sender; // 'buyer' | 'seller'
                  const currentRole = userIdString === counterOfferBuyerId?.toString() ? 'buyer' : 'seller';
                  if (isOfferExpired(latestCounterOffer)) return false;
                  // If there is a last sender and it matches the current role, it's NOT this user's turn
                  if (lastSender && lastSender === currentRole) return false;
                  return true;
                })() && (
                      <div className="flex flex-col md:flex-row gap-2 md:gap-3 mt-3">
                    {/* Accept/Reject only enabled when we have an offer id; Counter is always allowed on your turn */}
                    <button
                          onClick={async () => {
                            if (!activeCounterOfferId) return;
                            try {
                              setIsOfferActionLoading(true);
                              await approveCounterOffer(activeCounterOfferId);
                              toast.success("Offer accepted successfully!");
                              setShouldRefetch(true);
                          // refresh counter offers after action
                          try {
                            const carId = carDetailData?.data?.car?.id || routeCarId;
                            if (carId) {
                              const r = await getCounterOffersByCarId(carId);
                              const offers = Array.isArray(r?.data?.offers) ? r.data.offers : [];
                              const buyerId = r?.data?.buyer?.id || null;
                              const sellerId = r?.data?.seller?.id || null;
                              const sorted = [...offers].sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));
                              const latest = sorted[0];
                              setLatestCounterOffer(latest || null);
                              setActiveOfferPrice(latest ? Number(latest?.counterOfferPrice) : null);
                              setActiveCounterOfferId(latest?.id ?? null);
                              setCounterOfferBuyerId(buyerId);
                              setCounterOfferSellerId(sellerId);
                            }
                          } catch {}
                              // Redirect based on role
                              const redirectPath = isCarOwner ? "/user/account/local-cars" : "/user/account/order/local?tab=local&paid=not_paid";
                              navigate(redirectPath);
                            } catch (e) {
                              toast.error(e?.response?.data?.message || "Failed to accept offer");
                            } finally {
                              setIsOfferActionLoading(false);
                            }
                          }}
                          disabled={!activeCounterOfferId || isOfferActionLoading}
                          className={`px-4 py-2 rounded-md text-white ${!activeCounterOfferId || isOfferActionLoading ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}`}
                        >
                          {isOfferActionLoading ? "Processing..." : "Accept"}
                        </button>
                    <button
                          onClick={async () => {
                            if (!activeCounterOfferId) return;
                            try {
                              setIsOfferActionLoading(true);
                              await rejectCounterOffer(activeCounterOfferId);
                              toast.success("Offer rejected successfully!");
                              setShouldRefetch(true);
                          // refresh counter offers after action
                          try {
                            const carId = carDetailData?.data?.car?.id || routeCarId;
                            if (carId) {
                              const r = await getCounterOffersByCarId(carId);
                              const offers = Array.isArray(r?.data?.offers) ? r.data.offers : [];
                              const buyerId = r?.data?.buyer?.id || null;
                              const sellerId = r?.data?.seller?.id || null;
                              const sorted = [...offers].sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));
                              const latest = sorted[0];
                              setLatestCounterOffer(latest || null);
                              setActiveOfferPrice(latest ? Number(latest?.counterOfferPrice) : null);
                              setActiveCounterOfferId(latest?.id ?? null);
                              setCounterOfferBuyerId(buyerId);
                              setCounterOfferSellerId(sellerId);
                            }
                          } catch {}
                              // Redirect based on role
                              const redirectPath = isCarOwner ? "/user/account/local-cars" : "/user/account/order/local?tab=local&paid=not_paid";
                              navigate(redirectPath);
                            } catch (e) {
                              toast.error(e?.response?.data?.message || "Failed to reject offer");
                            } finally {
                              setIsOfferActionLoading(false);
                            }
                          }}
                          disabled={!activeCounterOfferId || isOfferActionLoading}
                          className={`px-4 py-2 rounded-md text-white ${!activeCounterOfferId || isOfferActionLoading ? "bg-gray-400 cursor-not-allowed" : "bg-red-600 hover:bg-red-700"}`}
                        >
                          {isOfferActionLoading ? "Processing..." : "Reject"}
                        </button>
                    <button
                          onClick={() => setIsCounterModalOpen(true)}
                          className="px-4 py-2 rounded-md text-white bg-blue-600 hover:bg-blue-700"
                        >
                          Counter
                        </button>
                      </div>
                )}
                  </div>
                </section>
              )}
              <div className="lg:hidden block">
                {!auctionEnded && hasBids && (
               <>
                <div>
                  <h2 className="text-md lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.375vw]">
                    Bid History
                  </h2>
                </div>
                <div className="h-[400px]   w-full overflow-auto shadow-md p-[1.5vw] ">
                  <div className="">
                    {allBids?.data?.data && allBids?.data?.data.length ? (
                      allBids?.data?.data
                        .sort(
                          (a, b) =>
                            new Date(b.bid?.createdAt) -
                            new Date(a.bid?.createdAt)
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            className="flex shadow-md rounded-lg p-4 lg:p-[0.5vw] mt-1 "
                          >
                            <div className="flex  items-center">
                              <img
                                className="w-[44px] lg:w-[2.29vw] lg:h-[2.29vw] h-[44px] rounded-lg"
                                src={item?.userDetails?.profilePicture}
                                alt="Profile"
                              />
                            </div>
                            <div className="flex justify-between w-full ml-4">
                              <div className="text-left">
                                <div className="flex items-center gap-2">
                                  <p className="text-[1rem] font-urbanist font-bold">
                                    {item?.bid?.userID?.substring(0, 8)}
                                  </p>
                                  <p className="text-[0.9rem] text-gray-500 font-urbanist">
                                    <TimeAgo date={item?.bid?.createdAt} />
                                  </p>
                                </div>
                                <p
                                  className={`text-[0.9rem] ${
                                    item?.bid?.isValid
                                      ? "text-green-600"
                                      : "text-red-600"
                                  } font-urbanist`}
                                >
                                  {item?.bid?.isValid ? "Winning" : "Outbidded"}
                                </p>
                              </div>
                              <div className="flex items-center">
                                <p
                                  className={`text-[1rem] font-urbanist font-bold ${
                                    item?.bid?.isValid
                                      ? "text-black"
                                      : "text-gray-500"
                                  }`}
                                >
                                  ${item?.bid?.bidPrice.toLocaleString()}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="h-[350px] flex items-center justify-center">
                        <p className="text-xl font-bold text-red-600">
                          No Bids Yet
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                </>
                )}
                <div className="mt-4">
                  <h2 className="text-md lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.375vw]">
                    Vehicle Report
                  </h2>
                  <ReportPreview vin={carDetailData?.data?.car?.vin} />
                </div>
              </div>
            </div>

            <div className=" hidden   lg:block w-full lg:w-[48%]">
              <div>
                <div className="flex  justify-between mt-[50px] lg:mt-2 lg:mb-[3vh]">
                  <div className="flex w-full justify-between px-[0.5vw] items-center gap-2 rounded-[0.5vw] bg-white">
                    {currentStatus && (
                      <div
                        className={`w-4 h-4 lg:w-[1.5vw] lg:h-[1.5vw] rounded-full ml-3 ${currentStatus?.bgHex}`}
                      >
                        <span
                          title={currentStatus.id}
                          className="text-white w-full h-full text-16 font-bold flex items-center justify-center"
                        >
                          {currentStatus.letter}
                        </span>
                      </div>
                    )}
                    <p className="lg:text-[1.7vw] mt-[10] font-urbanist font-semibold ">
                      {carDetailData?.data?.car?.year}{" "}
                      {carDetailData?.data?.car?.make}{" "}
                      {carDetailData?.data?.car?.model}
                    </p>
                    {typeof winningBid !== "undefined" && (
                      <span className="text-green-700 font-semibold text-[12px] lg:text-[0.9vw]">
                        {`Winning Bid: $${Number(winningBid).toLocaleString()}`}
                      </span>
                    )}

                    <div className="flex gap-x-[0.5vw] items-center">
                      <button
                        onClick={() => handleSaveClick(id)}
                        className="text-[12px] lg:text-18 font-semibold flex border items-center gap-2 lg:gap-[0.5vw] px-2 lg:px-[1vw] py-1 lg:py-[0.5vw] rounded-lg transition bg-gray-100 hover:bg-gray-200 text-gray-800"
                      >
                        {isCarSaved && user ? (
                          <BsHeartFill className=" text-red-500" />
                        ) : (
                          <BsHeart className=" text-gray-500" />
                        )}
                      </button>
                      <button
                        title="Copy URL"
                        onClick={() =>
                          document.getElementById("copy_url_modal").showModal()
                        }
                        className=" bg-blue-500 hover:bg-blue-600 text-white px-5 lg:px-[1.25vw] py-2 lg:py-[0.5vw] rounded-lg"
                      >
                        <FaLink className="lg:text-20" />
                      </button>
                    </div>
                  </div>
                </div>
                {/* <div className="flex justify-between bg-black rounded-[0.5vw] p-2 lg:mb-[2vh]">
                  <div className="flex justify-between w-full  items-center ">
                    <div className="font-urbanist bg-yellow-500/30 px-[1vw] py-[0.2vw] rounded-[0.5vw] font-semibold flex gap-x-2">
                      <span className=" text-black">Buy now price</span>
                      <span className="text-green-600 font-semibold">
                        {carDetailData?.data?.car?.buyNowPrice
                          ? `$${carDetailData?.data?.car?.buyNowPrice}`
                          : "Not Available"}
                      </span>
                    </div>
                    
                  </div>
                </div> */}
                <div className="flex gap-2 flex-col lg:flex-row justify-between   mb-[3vh]">
                  <div className="flex px-[0.5vw] gap-2 lg:gap-[0.5vw] items-center lg:w-[20vw] lg:h-[6.7vh] rounded-[0.5vw] bg-white">
                    <div className="flex justify-center items-center rounded-lg lg:rounded-[0.5vw] p-2 lg:w-[2.5vw] lg:h-[5vh] bg-[#CA0000]">
                      <PiUsersFill
                        color="white"
                        className="lg:w-[1.2vw] lg:h-[2.5vh]"
                      />
                    </div>
                    <div className="text-left  ">
                      <p className="lg:text-[0.7vw] text-[#7a798a]">Owned by</p>
                      <p className="lg:text-[0.9vw] font-urbanist font-semibold text-green-600   py-[0.1vw] px-[0.2vw] rounded-[0.2vw]">
                        {carDetailData?.data?.dealer?.dealershipName ||
                          "Private Party"}
                      </p>
                    </div>
                  </div>
                  <div className="flex px-[0.5vw] gap-2 lg:gap-[0.5vw]   items-center lg:w-[20vw] lg:h-[6.7vh] rounded-[0.5vw] bg-white">
                    <div className="flex justify-center items-center p-2 rounded-[0.5vw] lg:w-[2.5vw] lg:h-[5vh] bg-[#CA0000]">
                      <CgFileDocument
                        color="white"
                        className="lg:w-[1.2vw] lg:h-[2.5vh]"
                      />
                    </div>
                    <div className="text-left">
                      <p className="lg:text-[0.7vw] text-[#7a798a]">
                        Sale Platforms
                      </p>
                      <p className="lg:text-[0.9vw] font-urbanist font-semibold text-green-600  py-[0.1vw] px-[0.2vw] rounded-[0.2vw]">
                        Bidcaribbean
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex   flex-col lg:flex-row gap-2 justify-between">
                  <div className={`bg-white flex flex-col justify-evenly w-full ${auctionEnded ? 'lg:w-full' : 'lg:w-[20vw]'} px-[0.5vw] py-[1.08] leading-[4.33vh] rounded-lg`}>
                    <div className="flex items-center">
                      <p className="font-urbanist text-[#7a798a] lg:text-[0.85vw] ml-2">
                        VIN :
                      </p>
                      <p className="font-urbanist font-bold lg:text-[0.97vw] mx-2">
                        {carDetailData?.data?.car?.vin}
                      </p>
                      <RxCopy
                        title="Copy VIN"
                        className="cursor-pointer py-[0.1vh] text-[14px] text-gray-600 hover:text-gray-800"
                        onClick={() => {
                          navigator.clipboard.writeText(
                            carDetailData?.data?.car?.vin
                          );
                          toast.success("Copied to clipboard!");
                        }}
                      />
                    </div>
                    <div className="flex items-center">
                      <p className="font-urbanist text-[#7a798a] lg:text-[0.85vw] ml-2">
                        Year/Make :
                      </p>
                      <p className="font-urbanist font-bold lg:text-[0.97vw] ml-2">
                        {carDetailData?.data?.car?.year +
                          " " +
                          carDetailData?.data?.car?.make}
                      </p>
                    </div>
                    <div className="flex items-center">
                      <p className="font-urbanist text-[#7a798a] text-md lg:text-[0.85vw] ml-2">
                        Model:
                      </p>
                      <p className="font-urbanist font-bold lg:text-[0.97vw] ml-2">
                        {carDetailData?.data?.car?.model}
                      </p>
                    </div>
                  </div>
                  {!auctionEnded && (
                  <div className="flex flex-col  lg:w-[20vw]  leading-[4.33vh] rounded-[0.5vw] ">
                    <div className="flex flex-col bg-white px-[0.5vw] py-[1.08vh] justify-between rounded-[0.5vw]">
                      <div className="flex items-center">
                        <p className="font-urbanist text-[#7a798a] text-md lg:text-[0.85vw] ml-[0.5vw]">
                          Current Bid:
                        </p>

                        <p className="font-urbanist font-bold lg:text-[0.97vw] ml-2">
                          ${" "}
                          {currentBidValue.toLocaleString()}
                        </p>
                      </div>
                      <div className="flex items-center">
                        <p className="font-urbanist text-[#7a798a] text-md lg:text-[0.85vw] ml-[0.5vw]">
                          No of Bids :
                        </p>
                        <p className="font-urbanist font-bold text-md lg:text-[0.97vw] ml-[0.5vw]">
                          {liveData?.noOfBids || carDetailData?.data?.car?.noOfBids || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                  )}
                </div>
                {carDetailData?.data?.car?.auction_date ? (
                  ValidDate && (!buyNowPrice || currentBidValue < buyNowPrice) ? (
                    <>
                      <TimeLeftCounter
                        days={days}
                        hours={hours}
                        minutes={minutes}
                        seconds={seconds}
                      />
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                {getTimeDifference() ? (
                  <div
                    onClick={handleLiveAutcionNavigation}
                    className="flex justify-center hover:cursor-pointer my-[2vh] py-[0.5vw] items-center gap-x-[0.5vw] text-lg animate-pulse rounded-[0.7vw] text-white font-semibold bg-gradient-to-l from-green-700 to-green-600 hover:opacity-90 duration-300 shadow-md transform w-full"
                  >
                    {getTimeDifference()}
                  </div>
                ) : (
                  <div>
                    {user && userHasBid && userBidStatus && (
                      <div
                        className={`mt-2 mb-2 p-3 text-center font-semibold rounded-md text-white ${
                          userBidStatus === "winning"
                            ? "bg-green-600"
                            : userBidStatus === "outbid"
                            ? "bg-orange-500"
                            : userBidStatus === "won"
                            ? "bg-green-700"
                            : "bg-red-600"
                        }`}
                      >
                        {userBidStatus === "winning" && "You are currently Winning"}
                        {userBidStatus === "outbid" && "You have been Outbid"}
                        {userBidStatus === "won" && "You Won the Auction! 🎉"}
                        {userBidStatus === "lost" && "You Lost the Auction"}
                      </div>
                    )}
                    {ValidDate && (!buyNowPrice || currentBidValue < buyNowPrice) && (
                      <div className="mt-6">
                        <label className="block text-[20px] font-bold  lg:text-[0.875vw]   text-gray-900 mb-[1vh]">
                          Enter Your Final Bid
                        </label>
                        <CurrencyInput
                          id="input-example"
                          name="minPrice"
                          placeholder="Enter your bid amount in USD"
                          prefix="$"
                          className={`border lg:text-[1vw] py-[0.9vh] px-[1vw] rounded-[0.5vw] w-full mt-[1.5vh] bg-white`}
                          defaultValue={0}
                          decimalsLimit={2}
                          value={bidAmount}
                          onValueChange={(value) => setBidAmount(value)}
                          disabled={isCarOwner}
                        />
                      </div>
                    )}
                    <button
                      onClick={handlePlaceBid}
                      className={`flex justify-center mt-[2.167vh] items-center gap-x-[0.5vw] h-[5.4vh] text-lg mb-[2.167vh] rounded-[0.7vw] text-white font-semibold w-full ${
                        isCarOwner
                          ? "bg-red-600 cursor-not-allowed"
                          : !ValidDate
                          ? "bg-gray-500 cursor-not-allowed opacity-50"
                          : buyNowPrice && currentBidValue >= buyNowPrice
                          ? "bg-gray-300 cursor-not-allowed"
                          : Number(bidAmount) <= currentBidValue
                          ? "bg-red-600 cursor-not-allowed"
                          : "bg-red-600 hover:bg-red-700"
                      }`}
                      disabled={
                        isCarOwner || !ValidDate || (buyNowPrice && currentBidValue >= buyNowPrice) || Number(bidAmount) <= currentBidValue
                      }
                    >
                      {placebidLoading ? (
                        <ClipLoader color="#ffffff" size={20} />
                      ) : (
                        <>
                          <TiLockClosed className="lg:w-[1.3vw] lg:h-[2.8vh]" />
                           <span className="text-md lg:text-[1.1vw]">
                             {isCarOwner
                               ? "This car belongs to you"
                               : !ValidDate || (buyNowPrice && currentBidValue >= buyNowPrice)
                               ? "AUCTION ENDED"
                               : "PLACE MAX BID"}
                           </span>
                        </>
                      )}
                      {Number(bidAmount) <= currentBidValue && ValidDate && (!buyNowPrice || currentBidValue < buyNowPrice) && (
                        <TooltipInfo content="please place higher than current bid">
                          <BsInfoCircle size={15} className="hover:text-blue-800 duration-200" />
                        </TooltipInfo>
                      )}
                    </button>

                    {buyNowPrice != null && (
                      <button
                        onClick={handleBuyNowClick}
                        className={`flex justify-center mt-[2.167vh] items-center gap-x-[0.5vw] h-[5.4vh] text-lg mb-[2.167vh] rounded-[0.7vw] text-white font-semibold bg-gradient-to-l duration-300 transform w-full ${
                          isCarOwner
                            ? "from-green-700 to-green-600 hover:opacity-90"
                            : !ValidDate
                            ? "bg-gray-500 cursor-not-allowed opacity-50"
                            : currentBidValue >= buyNowPrice
                            ? "bg-red-600 cursor-not-allowed"
                            : "from-green-700 to-green-600 hover:opacity-90"
                        }`}
                        disabled={isCarOwner || !ValidDate || currentBidValue >= buyNowPrice}
                      >
                        <>
                          <span className="text-md lg:text-[1.1vw]">
                            {!ValidDate || currentBidValue >= buyNowPrice ? "FINAL BID PRICE" : "BUY NOW"}
                          </span>
                          <span className="text-md lg:text-[1.1vw]">
                            {!ValidDate || currentBidValue >= buyNowPrice
                              ? (typeof winningBid !== "undefined" ? Number(winningBid) : currentBidValue).toLocaleString("en-US", { style: "currency", currency: "USD" })
                              : buyNowPrice != null
                              ? buyNowPrice.toLocaleString("en-US", { style: "currency", currency: "USD" })
                              : "N/A"}
                          </span>
                        </>
                      </button>
                    )}
                    {buyNowPrice == null && auctionEnded && (
                      <button
                        disabled
                        className={
                          "flex justify-center mt-[2.167vh] items-center gap-x-[0.5vw] h-[5.4vh] text-lg mb-[2.167vh] rounded-[0.7vw] text-white font-semibold w-full bg-gray-500 cursor-not-allowed opacity-50"
                        }
                      >
                        <span className="text-md lg:text-[1.1vw]">FINAL BID PRICE</span>
                        <span className="text-md lg:text-[1.1vw]">
                          {(typeof winningBid !== "undefined" ? Number(winningBid) : currentBidValue).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </span>
                      </button>
                    )}
                  </div>
                )}

                <div>
                  {!auctionEnded && hasBids && (
                  <>
                  <div>
                    <h2 className="text-md lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.375vw]">
                      Bid History
                    </h2>
                  </div>
                  <div className="h-[400px] lg:h-[21vw] w-full overflow-auto shadow-md p-[1.5vw] bg-white">
                    <div className="">
                      {allBids?.data?.data && allBids?.data?.data.length ? (
                        allBids?.data?.data
                          .sort(
                            (a, b) =>
                              new Date(b.bid.createdAt) -
                              new Date(a.bid.createdAt)
                          )
                          .map((item, index) => (
                            <div
                              key={index}
                              className="flex shadow-md rounded-lg p-4 lg:p-[1vw] mt-1 "
                            >
                              <div className="flex  items-center">
                                <img
                                  className="w-[44px] lg:w-[2.29vw] lg:h-[2.29vw] h-[44px] rounded-lg"
                                  src={item?.userDetails?.profilePicture}
                                  alt="Profile"
                                />
                              </div>
                              <div className="flex justify-between w-full ml-4">
                                <div className="text-left">
                                  <div className="flex items-center gap-2">
                                    <p className="text-[1vw] font-urbanist font-bold">
                                      {item?.bid?.userID?.substring(0, 8)}
                                    </p>
                                    <p className="text-[1vw] text-gray-500 font-urbanist">
                                      <TimeAgo date={item?.bid?.createdAt} />
                                    </p>
                                  </div>
                                  <p
                                    className={`text-[1vw] ${
                                      item?.bid?.isValid
                                        ? "text-green-600"
                                        : "text-red-600"
                                    } font-urbanist`}
                                  >
                                    {item?.bid?.isValid ? "Winning" : "Outbidded"}
                                  </p>
                                </div>
                                <div className="flex items-center">
                                  <p
                                    className={`text-[1vw] font-urbanist font-bold ${
                                      item?.bid?.isValid
                                        ? "text-black"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    ${item?.bid?.bidPrice.toLocaleString()}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))
                      ) : (
                        <div className="h-[350px] flex items-center justify-center">
                          <p className="leader text-[1.5vw] lg:text-[1.25vw] font-bold text-red-600">
                            No Bids Yet
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  </>
                  )}
                  <div className="mt-4">
                    <h2 className="text-md lg:text-[1.2vw] font-semibold bg-gray-300 mb-[2vh] border-b-2 border-gray-200 p-[0.5vw] rounded-[0.375vw]">
                      Vehicle Report
                    </h2>
                    <ReportPreview vin={carDetailData?.data?.car?.vin} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <SimilarCars
              make={carDetailData?.data?.car?.make}
              model={carDetailData?.data?.car?.model}
              year={carDetailData?.data?.car?.year}
            />
          </div>
          <CopyURLModal
            closeModal={() => document.getElementById("copy_url_modal").close()}
          />
        </div>
      )}
      <LoginModal
        isOpen={isLoginModalOpen && !user}
        onClose={closeLoginModal}
      />
      <SignInModal
        closeModal={() => document.getElementById("sign_in_modal").close()}
      />
      <BidConfirmationModal
        totalFunds={totalFunds}
        isLoading={placebidLoading}
        onBidPlace={handleBidPlace}
        onClose={handleCloseBidModal}
        bidAmount={bidAmount}
      />

      {/* Counter Offer Modal */}
      <CounterOfferModal
        isOpen={isCounterModalOpen}
        onClose={() => { setIsCounterModalOpen(false); setCounterOfferAmount(""); }}
        onSubmit={async () => {
          if (!counterOfferAmount || isNaN(Number(counterOfferAmount))) return;
          const numeric = Number(counterOfferAmount);
          const minAllowed = Number(currentBidValue) || 0;
          if (numeric < minAllowed) {
            toast.error(`Counter offer must be at least ${minAllowed.toLocaleString("en-US", { style: "currency", currency: "USD" })}`);
            return;
          }
          try {
            setIsOfferActionLoading(true);
            await createCounterOffer({
              carID: carDetailData?.data?.car?.id,
              counterOfferPrice: Number(counterOfferAmount),
              sender: isCarOwner ? "seller" : "buyer",
              carTitle: carDetailData?.data?.car?.title || `${carDetailData?.data?.car?.year || ""} ${carDetailData?.data?.car?.make || ""} ${carDetailData?.data?.car?.model || ""}`.trim()
            });
            toast.success("Counter offer submitted successfully!");
            setIsCounterModalOpen(false);
            setCounterOfferAmount("");
            setActiveOfferPrice(Number(counterOfferAmount));
            // After user submits a counter offer, hide action buttons until a new seller offer arrives
            setActiveCounterOfferId(null);
            setShouldRefetch(true);
            // Redirect based on role after successful counter
            const redirectPath = isCarOwner ? "/user/account/local-cars" : "/user/account/order/local?tab=local&paid=not_paid";
            navigate(redirectPath);
          } catch (e) {
            const msg = e?.response?.data?.message || "Failed to submit counter offer";
            toast.error(msg);
          } finally {
            setIsOfferActionLoading(false);
          }
        }}
        amount={counterOfferAmount}
        setAmount={setCounterOfferAmount}
        carTitle={carDetailData?.data?.car?.title || `${carDetailData?.data?.car?.year || ""} ${carDetailData?.data?.car?.make || ""} ${carDetailData?.data?.car?.model || ""}`.trim()}
        minAmount={Number(currentBidValue) || 0}
        isLoading={isOfferActionLoading}
      />

      <dialog id="buy_now_modal" className="modal">
        <div className="modal-box dark:bg-white">
          {totalFunds <= 0 && (
            <div className="bg-[#e73f07e8] text-white text-center py-2 lg:py-[0.2vw] mb-2">
              <h2 className="text-md md:text-lg lg:text-20 font-semibold">
                You are almost set. Please{" "}
                <Link
                  to={"/user/account/funds"}
                  className="hover:text-blue-700 underline"
                >
                  add deposit
                </Link>{" "}
                to be able to bid
              </h2>
            </div>
          )}
          <h3 className="font-bold text-lg">Confirm Purchase</h3>
          <div className="p-2 bg-green-700 font-bold flex justify-between text-white rounded-md">
            <span>Buy It Now </span>
            <span>
              {formatCurrency(carDetailData?.data?.car?.buyNowPrice)} USD
            </span>
          </div>
          <p className="py-4">
            {`By clicking on the 'Confirm Purchase' button below, you are committing to buy this vehicle if you are the winning bidder. All bids are final.`}
          </p>
          <div className="flex gap-x-2 justify-center">
            {placebidLoading ? (
              <button
                className="btn text-green-600  dark:bg-white hover:bg-gray-200 border-green-600"
                onClick={handleBuyNow}
                disabled={isCarOwner}
              >
                <ClipLoader color="#CA0000" size={20} />
              </button>
            ) : (
              <button
                className={`btn text-green-600  dark:bg-white hover:bg-gray-200 border-green-600 ${isCarOwner ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={handleBuyNow}
                disabled={isCarOwner}
              >
                Confirm Purchase
              </button>
            )}
            <button
              className="btn text-red-600 w-[100px] dark:bg-white hover:bg-gray-200 border-red-600"
              onClick={() => document.getElementById("buy_now_modal").close()}
            >
              Cancel
            </button>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default LocalVehicleDetail;

const InfoRow = ({ label, value }) => (
  <div className="flex justify-between">
    <p className="text-gray-600 font-medium">{label}:</p>
    <span className="text-black">{value}</span>
  </div>
);